import { RichText } from "components/slices/RichText";
import { Link } from "components/Link";
import { Checkbox, Form, Input } from "components/Form";
import { SMALL } from "shared/variables";
import { SpacingSection } from "components/SpacingSection";
import { useState } from "react";
import { useAppContext } from "shared/useAppContext";

import cx from "classnames";
import styles from "./RegistrationForm.module.css";

export const RegistrationFormWrapper = ({ id, uid, primary }) => {
  return (
    <RegistrationForm
      sliceId={id}
      uid={uid}
      lead={primary.lead}
      successMessage={primary.successMessage}
    />
  );
};

export const RegistrationForm = ({ sliceId, uid, lead, successMessage }) => {
  const { formSettings } = useAppContext();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const termsLink = formSettings.data.terms_link;

  const onSubmit = async (data) => {
    const response = await fetch(`/api/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, uid, sliceId }),
    }).then((r) => r.json());

    if (response?.error) {
      console.error(response.error);
      setError("Er is iets misgegaan");
    } else {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <>
        <RichText content={lead} />
        <div className={cx(styles.successMessage)}>
          <RichText content={successMessage} />
        </div>
      </>
    );
  }

  return (
    <div className={cx(styles.registrationForm)}>
      <RichText content={lead} />
      <Form onSubmit={onSubmit} error={error}>
        <Input
          error={error}
          name="firstName"
          label="Voornaam*"
          required={true}
        />
        <Input error={error} name="name" label="Achternaam*" required={true} />
        <Input error={error} name="city" label="Woonplaats*" required={true} />
        <Input
          error={error}
          name="email"
          type="email"
          label="E-mailadres*"
          required={true}
        />
        <Input
          error={error}
          name="phone"
          type="tel"
          label="Telefoonnummer*"
          required={true}
        />

        <Checkbox
          error={error}
          name="acceptsTerms"
          label={
            <span>
              Ik ga akkoord met het verwerken van mijn gegevens volgens de{" "}
              <Link field={termsLink} target="_blank">
                privacy voorwaarden*
              </Link>
            </span>
          }
          required={true}
        />
      </Form>
    </div>
  );
};
